export default __webpack_public_path__ + "static/mobile-img-on-top-addb0e26d2b3919c49a432f9b1051776.png";